import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ErpModule } from '@/api/platform.api';
import { TOUR_STEPS, type TourStepDefinition } from '@/core/tour/tourConfig';

export function useLocalizedTourSteps(module: ErpModule | null): TourStepDefinition[] {
  const { t } = useTranslation('common');

  return useMemo(() => {
    if (!module) return [];
    const steps = TOUR_STEPS[module] ?? [];
    return steps.map((step) => ({
      ...step,
      title: t(`tour.steps.${module}.${step.id}.title`, { defaultValue: step.title }),
      description: t(`tour.steps.${module}.${step.id}.description`, {
        defaultValue: step.description,
      }),
      actionLabel: t(`tour.steps.${module}.${step.id}.actionLabel`, {
        defaultValue: step.actionLabel,
      }),
    }));
  }, [module, t]);
}
